import {
  type FilterKey,
  FILTER_PRIORITY_DISPLAY_THRESHOLD,
  type SuppliedFilterProviderOptions,
} from '@github-ui/filter-core'
import {BaseUserFilterProvider, type UserFilterParams} from '@github-ui/filter-core/providers'
import {PersonIcon} from '@primer/octicons-react'

// Colocated in dashboard-surface (rather than the shared filter-core registry) because
// review-involves is a /pulls-only reviewer qualifier owned by our team. The Filter resolves
// tokens against each provider instance's own key, so a local FilterKey suggests and parses
// without a shared-registry entry.
//
// Priority is FILTER_PRIORITY_DISPLAY_THRESHOLD (not NOT_SHOWN) on purpose: key suggestions are
// filtered to priority <= FILTER_PRIORITY_DISPLAY_THRESHOLD (filter-core/filter-query.ts). The
// shared useFilterProviders hook caps its NOT_SHOWN providers down to that threshold, but we
// compose this provider outside that hook, so we set the displayable priority directly.
export const REVIEW_INVOLVES_FILTER_KEY: FilterKey = {
  displayName: 'Review involves',
  key: 'review-involves',
  icon: PersonIcon,
  description: 'Items the user is involved in reviewing',
  priority: FILTER_PRIORITY_DISPLAY_THRESHOLD,
}

export class ReviewInvolvesFilterProvider extends BaseUserFilterProvider {
  constructor(filterParams?: UserFilterParams, options?: SuppliedFilterProviderOptions) {
    super(REVIEW_INVOLVES_FILTER_KEY, filterParams, options)
  }
}
